export const colorArray = [
    '#FF1744', '#3F51B5', '#4CAF50', '#FF9800', '#9C27B0', '#00BCD4',
    '#795548', '#607D8B', '#E91E63', '#2196F3', '#8BC34A', '#FF5722',
    '#9E9E9E', '#673AB7', '#FFEB3B'
]